export default __webpack_public_path__ + "static/media/IMG-20241210-WA0030.41ead100.jpg";